import { Channel } from '@gooduncles/gu-app-schema';

import { updateChannel } from 'src/utils/firebase/firebase-short-cut';

/**
 * 콘솔 받은편지함의 팀 공유 안읽음 플래그를 해제한다 (관리자가 채널을 열었을 때).
 *
 * ⚠️ 반드시 dotted 경로로 부분 갱신한다. `{ consoleInbox: { adminUnread: false } }`로
 * 넘기면 consoleInbox 객체 전체가 교체되어 lastMessageAt/lastMessagePreview/
 * lastMessageSenderService가 날아간다. dotted 키는 Channel 타입에 없으므로 캐스팅한다.
 */
export const markChannelInboxRead = (channelId: string) =>
  updateChannel(channelId, { 'consoleInbox.adminUnread': false } as unknown as Partial<Channel>);
